import { RootState } from '@app/redux/root-reducer';

const slice = (state: RootState) => state.selectIngredientsScreenReducer;

export const getSelectedIngredients = (state: RootState) => slice(state).selectedIngredients;
